import { defineStore } from 'pinia'

export function createPaginatedListStore(name, useDataModelStore) {
    return  defineStore('list-' + name, {
        state: () => {
            return {
            queryId: null,
            useCache: true
            }
        },
        getters: {
            items() {
                if (!this.queryId) {
                    return [];
                }

                const dataModelStore = useDataModelStore();
                return dataModelStore.items(this.queryId);
            },
            meta() {
                if (!this.queryId) {
                    return { page: 0, pages: 0, pageSize: 0, total: 0 };
                }

                const dataModelStore = useDataModelStore();
                const response = dataModelStore.response(this.queryId);
                if (!response) {
                    return { page: 0, pages: 0, pageSize: 0, total: 0 };
                }

                return response.meta;
            },
            loading() {
                if (!this.queryId) {
                    return false;
                }

                const dataModelStore = useDataModelStore();
                return dataModelStore.loading(this.queryId);
            },
            error() {
                if (!this.queryId) {
                    return false;
                }

                const dataModelStore = useDataModelStore();
                return dataModelStore.error(this.queryId);
            }
        },
        actions: {
            requestRefresh() {
                this.useCache = false;
            },
            cleanup() {
                this.queryId = null;
                this.useCache = true;
            },
            async fetchPage(query = {}, extra = {}) {
                const key = `${name}_FETCH_PAGE`;
                const dataModelStore = useDataModelStore();

                if (!this.useCache) {
                    dataModelStore.cleanup(true);
                }
                this.queryId = await dataModelStore.fetchItems({ key, query, useCache: this.useCache, extra });
                this.useCache = true;
            },
            removeItem(item) {
                const dataModelStore = useDataModelStore();
                dataModelStore.removeItem(item);
            }
        }
    });
}

export const usePaginatedListStore = createPaginatedListStore;
